import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { PageHeader } from "@/components/ui-bits";
import UsersPanel from "@/components/admin/UsersPanel";
import RolesPanel from "@/components/admin/RolesPanel";
import LocationsPanel from "@/components/admin/LocationsPanel";
import AuditLogPanel from "@/components/admin/AuditLogPanel";
import ImportRecipesPanel from "@/components/admin/ImportRecipesPanel";
import SubstitutionSettingsPanel from "@/components/admin/SubstitutionSettingsPanel";
import ShiftSettingsPanel from "@/components/admin/ShiftSettingsPanel";
import StockResetPanel from "@/components/admin/StockResetPanel";

export default function Admin() {
  return (
    <div>
      <PageHeader title="Admin" eyebrow="System · Users & locations" />
      <Tabs defaultValue="users" className="space-y-6">
        <TabsList>
          <TabsTrigger value="users" data-testid="tab-users">Users</TabsTrigger>
          <TabsTrigger value="roles" data-testid="tab-roles">Roles</TabsTrigger>
          <TabsTrigger value="locations" data-testid="tab-locations">Locations</TabsTrigger>
          <TabsTrigger value="audit" data-testid="tab-audit">Audit Log</TabsTrigger>
          <TabsTrigger value="import" data-testid="tab-import">Import</TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="users"><UsersPanel /></TabsContent>
        <TabsContent value="roles"><RolesPanel /></TabsContent>
        <TabsContent value="locations"><LocationsPanel /></TabsContent>
        <TabsContent value="audit"><AuditLogPanel /></TabsContent>
        <TabsContent value="import"><ImportRecipesPanel /></TabsContent>
        <TabsContent value="settings">
          <ShiftSettingsPanel />
          <div className="h-6" />
          <SubstitutionSettingsPanel />
          <div className="h-6" />
          <StockResetPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
